export default "/images/framework/MyScoreEng.b1f0b594.svg?b1f0b594";